import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import useStyles from './useStyles';

const googleCLientId = process.env.GOOGLE_CLIENT_ID;

const GoogleAuthButton = props => {
  const { onSuccess } = props;
  const classes = useStyles();

  const buttonRef = useRef(null);

  useEffect(() => {
    window.google.accounts.id.initialize({
      client_id: googleCLientId,
      callback: onSuccess,
    });
  }, []);

  useEffect(() => {
    if (buttonRef.current) {
      window.google.accounts.id.renderButton(buttonRef.current, {
        shape: 'circle',
        theme: 'outline',
        size: 'large',
        locale: 'en',
        width: '300',
        text: 'continue_with',
      });
    }
  }, [buttonRef]);

  return <div className={classes.root} ref={buttonRef} />;
};

GoogleAuthButton.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  // type: PropTypes.string,
};

// GoogleAuthButton.defaultProps = {
//   type: 'continue_with',
// };

export default GoogleAuthButton;



// WEBPACK FOOTER //
// ./src/sharedComponents/GoogleAuthButton/GoogleAuthButton.js